import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

const scrollToTop = () => {
    const scrollableContainer = document.getElementsByTagName('html')[0];
    if (scrollableContainer) {
        scrollableContainer.scrollTo(0, 0);
    }
};

const ScrollToTopWrapper = ({ children, doScroll, onScrollComplete }) => {
    const location = useLocation();

    useEffect(() => {
        
        scrollToTop();
    }, [location.pathname]);

    if (doScroll) {
        scrollToTop();
        onScrollComplete();
    }

    return children;
};

ScrollToTopWrapper.propTypes = {
    
    children: PropTypes.node.isRequired
};

export default ScrollToTopWrapper;
